import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Page, PageHeader, Alert, Loading } from '../../ui';
import { api } from '../../ui/api';
import ServiceForm from './ServiceForm';

const ViewService = () => {
  const { id } = useParams();
  const [service, setService] = useState(null);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    api(`/service/${id}`).then(setService).catch((e) => setError(e.message));
  }, [id, version]);

  const save = async (payload) => {
    const updated = await api(`/service/${id}`, { method: 'PUT', body: payload });
    setService(updated && updated.id ? updated : null);
    setSaved(true);
    setVersion((v) => v + 1); // remount the form with the saved values
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Page>
      <PageHeader
        title={service ? service.service_name : 'Service'}
        subtitle={service ? `${service.service_id || ''}${service.category ? ` · ${service.category.name}` : ''}` : undefined}
        back={{ to: '/manage-services', label: 'Services' }}
      />
      <Alert>{error}</Alert>
      {saved && <Alert tone="success">Changes saved.</Alert>}
      {!service && !error ? <Loading /> : service && (
        <ServiceForm key={version} initial={service} onSave={save} submitLabel="Save changes" />
      )}
    </Page>
  );
};

export default ViewService;
